import { useState } from 'react';

import type { ProviderEntry } from '#core/lib/expr/providers/useProviderRegistry.ts';

import { useAppProvider } from '#plugin-chat';

import { useCatalogViews } from '#instructions/virtualViews/catalog/index.ts';
import type { VirtualView } from '#instructions/virtualViews/createReshapedView.ts';

/**
 * Registers the iPSO virtual-view providers into the chat session's
 * knowledge-graph group. Mounted INSIDE `<Chat>` so the provider-building
 * catalog hooks run within session context (CDF client, etc.) and can win
 * first-claim resolution over same-named CDF views. Renders nothing.
 */
export function AppProviders() {
  const views = useCatalogViews();
  const [entries] = useState(
    views.map((view: VirtualView): ProviderEntry => ({ provider: view.provider, names: [view.name] })),
  );

  useAppProvider(entries);
  return null;
}
